import { Archive, CircleCheck, CircleX, Eye, FileText, FileX2, Gavel, HandCoins, Handshake, Hourglass, Mail, Pause, PencilLine, PieChart, Scale, type LucideIcon } from "lucide-react";
import { TONES, type StatusTone } from "../../components/filters/statusColors";

/* Filter chips wear the same tones and icons as the status pills they filter
   for (statusColors TONES). Grouped and module-specific labels don't resolve
   by name, so each option names its tone here. */
const toneOpt = (tone: StatusTone, toneIcon: LucideIcon) => ({ tone, toneIcon });
export const GROUP_TONE: Record<string, { tone: StatusTone; toneIcon: LucideIcon }> = {
  draft: toneOpt(TONES.neutral, PencilLine),
  editor: toneOpt(TONES.info, Eye),
  approval: toneOpt(TONES.attention, Hourglass),
  active: toneOpt(TONES.success, CircleCheck),
  partial: toneOpt(TONES.success, PieChart),
  paused: toneOpt(TONES.attention, Pause),
  disposition: toneOpt(TONES.decision, Scale),
  disposed: toneOpt(TONES.neutral, Archive),
  closed: toneOpt(TONES.danger, CircleX),
};
// Same hues the entry page already gives each communication type.
export const COMM_TYPE_TONE: Record<number, { tone: StatusTone; toneIcon: LucideIcon }> = {
  1: toneOpt(TONES.info, Mail),
  2: toneOpt(TONES.escalated, FileText),
  3: toneOpt(TONES.danger, Gavel),
};
export const DISPOSITION_TONE: Record<number, { tone: StatusTone; toneIcon: LucideIcon }> = {
  1: toneOpt(TONES.neutral, FileX2),
  2: toneOpt(TONES.success, HandCoins),
  3: toneOpt(TONES.success, Handshake),
  4: toneOpt(TONES.escalated, Gavel),
};
